import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';
import { HorizontalTabNav } from 'components/common/horizontalTabNav';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const TabNav = React.memo(() => {
  const { pathname } = useLocation();
  const { hasAccess } = useAccessControl();

  const navigationItems = useMemo(() => {
    const items = [
      {
        path: ADMIN_ROUTES.country.management,
        label: 'Management',
        permission: PERMISSIONS.countries.tabs.management.read,
        id: '1',
      },
      {
        path: ADMIN_ROUTES.country.shipping,
        label: 'Shipping',
        permission: PERMISSIONS.countries.tabs.shipping.read,
        id: '2',
      },
      {
        path: ADMIN_ROUTES.country.warehouses,
        label: 'Warehouses',
        permission: PERMISSIONS.countries.tabs.warehouse.read,
        id: '3',
      },
      {
        path: ADMIN_ROUTES.country.pricing,
        label: 'Pricing',
        permission: PERMISSIONS.countries.tabs.pricing.read,
        id: '4',
      },
      {
        path: ADMIN_ROUTES.country.tasks,
        label: 'Tasks',
        permission: PERMISSIONS.countries.tabs.task.read,
        id: '5',
      },
      {
        path: ADMIN_ROUTES.country.logs,
        label: 'Logs',
        permission: PERMISSIONS.countries.tabs.logs.read,
        id: '6',
      },
    ];

    return items.filter((i) => hasAccess(i.permission));
  }, [hasAccess]);

  return <HorizontalTabNav pathname={pathname} navigationItems={navigationItems} />;
});
